<template>
  <div class="erp">

  </div>
</template>

<script>
export default {
  name:"erp",
    data() {
        return {

        }
    },
    created(){},
    mounted(){},
    watch:{},
    methods:{

    }


}
</script>

  
  <style lang="scss" >
@import 'erp.scss'; 

  </style>